import React, { useEffect, useState } from "react";
import FadeLoader from "react-spinners/FadeLoader";
import Select from "react-select";
import Modal from "react-modal";

import { overridestampdocument } from "@safecv/shared/sharedFunction";
import {
  getStandardStamps,
  fetchFavouriteAnnotation,
} from "@safecv/actions/postActions";
import API_CONFIG from "@safecv/src/api-config";

import Cross from "@safecv/assets/Images/cross.png";

import "./StampModalComponent.css";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0px",
    width: "70%",
    height: "87%",
    overflow: "hidden",
    borderRadius: "0px",
    transform: "translate(-50%, -50%)",
  },
};

const colourStylesStamps = {
  container: (styles) => ({
    ...styles,
    zIndex: 2,
    width: "100%",
    fontSize: "12px",
    fontWeight: "600",
    fontFamily: "Lato",
    fontStyle: "normal",
  }),
  control: (styles) => ({
    ...styles,
    height: "35px",
    marginBottom: 0,
    boxShadow: "none",
    cursor: "pointer",
    borderRadius: "35px",
    border: "1px solid #E5E5E5",
    "&:hover": {
      border: "1px solid #4183C5",
    },
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#676767",
    fontWeight: "normal",
  }),
  menu: (styles) => ({
    ...styles,
    marginTop: 4,
    zIndex: 9999,
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
};

const pageOption = [
  { value: 1, label: `Current Page` },
  { value: 2, label: "Custom" },
  { value: 3, label: "All" },
];

const StampModalComponent = (props) => {
  const {
    jobId,
    pdfPages,
    isStampModalOpen,
    instance,
    stampToolName,
    setIsStampModalOpen,
    setSelectedStampDocument,
    stampTabActive,
    setStampTabActive,
    selectedFavAnnotId,
    setSelectedFavAnnotId,
  } = props;

  const [stampImage, setStampImage] = useState([]);
  const [stampLoading, setStampLoading] = useState(false);
  const [customPageInput, setCustomPageInput] = useState("");
  const [customPageErrMsg, setCustomPageErrMsg] = useState(null);
  const [customPageInputFlag, setCustomPageInputFlag] = useState(false);
  const [selectedPageMode, setSelectedPageMode] = useState(pageOption[0]);
  const [stampMetaData, setStampMetaData] = useState([]);
  const [currentPageFlag, setCurrentPageFlag] = useState(true);
  const [favAnnotationList, setFavAnnotationList] = useState([]);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [selectedStampBase64, setSelectedStampBase64] = useState(null);
  const [selectedStampBase64Loader, setSelectedStampBase64Loader] = useState(
    false
  );

  const handleModalClose = () => {
    setIsStampModalOpen(false);
    setSelectedPageMode(pageOption[0]);
    setCustomPageInputFlag(false);
    setSelectedStampBase64(null);
    setCustomPageErrMsg(null);
    setCustomPageInput("");
  };

  const handlecustomPageInputChange = (e) => {
    if (e.target.value.match(/^(\d+(-\d+)?, ?)*(\d+-?\d*)?$/) !== null) {
      setCustomPageInput(e.target.value);
    }
  };

  const toDataURL = (url, callback) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  };

  const handleStampClick = (stim, index) => {
    setSelectedImageIndex(index);
    setSelectedStampBase64Loader(true);
    toDataURL(stim, function (dataUrl) {
      setSelectedStampBase64(dataUrl);
      setSelectedStampBase64Loader(false);
    });
  };

  const handlePageModeChange = (selectedOption) => {
    setSelectedPageMode(selectedOption);
    if (selectedOption.value === 3) {
      setCustomPageInputFlag(false);
      setCurrentPageFlag(false);
      setCustomPageInput("");
    } else if (selectedOption.value === 2) {
      setCustomPageInputFlag(true);
      setCurrentPageFlag(false);
    } else {
      // stamp current page
      setCustomPageInputFlag(false);
      setCurrentPageFlag(true);
    }
  };

  const createCustomPageArray = () => {
    let pagesArray = [];
    let errorFlag = false;
    let splitedInputs = customPageInput.split(",");

    for (let i = 0; i < splitedInputs.length; i++) {
      let input = splitedInputs[i].trim();
      let multipages = input.split("-");
      if (multipages.length === 1) {
        if (Number(multipages[0]) <= 0) {
          errorFlag = true;
          setCustomPageErrMsg(`Invalid page range, use e.g. 1-5, 8, 11-13`);
          break;
        } else if (
          Number(multipages[0]) > 0 &&
          Number(multipages[0]) > pdfPages
        ) {
          errorFlag = true;
          setCustomPageErrMsg(
            `Out of bounds page reference, limit is ${pdfPages}`
          );
          break;
        } else {
          pagesArray.push(Number(multipages[0]));
        }
      } else if (multipages.length > 1) {
        if (!multipages[0] || !multipages[1]) {
          errorFlag = true;
          setCustomPageErrMsg(`Invalid page range, use e.g. 1-5, 8, 11-13`);
          break;
        } else {
          if (Number(multipages[0]) <= 0 || Number(multipages[1]) <= 0) {
            errorFlag = true;
            setCustomPageErrMsg(`Invalid page range, use e.g. 1-5, 8, 11-13`);
            break;
          } else if (
            (Number(multipages[0]) > 0 && Number(multipages[0]) > pdfPages) ||
            (Number(multipages[1]) > 0 && Number(multipages[1]) > pdfPages)
          ) {
            errorFlag = true;
            setCustomPageErrMsg(
              `Out of bounds page reference, limit is ${pdfPages}`
            );
            break;
          } else if (Number(multipages[0]) > Number(multipages[1])) {
            errorFlag = true;
            setCustomPageErrMsg(`Invalid page range, use e.g. 1-5, 8, 11-13`);
            break;
          } else {
            for (let j = multipages[0]; j <= multipages[1]; j++) {
              pagesArray.push(Number(j));
            }
          }
        }
      }
    }
    if (!errorFlag) {
      let uniquePagesArray = [...new Set(pagesArray)];
      handleModalSave(uniquePagesArray);
    }
  };

  const handleModalProceed = () => {
    if (customPageInput === "" && !customPageInputFlag) {
      handleModalSave();
    } else {
      createCustomPageArray();
    }
  };

  const handleModalSave = async (uniquePagesArray) => {
    instance.UI.setToolMode(stampToolName);
    const imgtest = document.getElementById(`stampimage${selectedImageIndex}`);
    const createdStampObject = {
      url: selectedStampBase64,
      currentPageFlag: currentPageFlag,
      stampWidth: imgtest.naturalWidth,
      stampHeight: imgtest.naturalHeight,
      customPageStampingArray: uniquePagesArray,
      stampMetaData: stampMetaData[selectedImageIndex],
    };
    setSelectedStampDocument(createdStampObject);
    handleModalClose();
  };

  const handleFavAnnot = () => {
    instance.UI.setToolMode(props.freeTextToolName);
    handleModalClose();
  };

  useEffect(() => {
    async function getJurisdictionStamp() {
      let jurisdictionStamps = await getStandardStamps(jobId);
      let jurisdictionStampsImages =
        jurisdictionStamps &&
        jurisdictionStamps.map((d) => API_CONFIG.API_ROOT.concat(d.url));
      let jurisdictionStampsMetaData =
        jurisdictionStamps &&
        jurisdictionStamps.map((d) => {
          return d.stampMetadata;
        });
      setStampMetaData([...jurisdictionStampsMetaData]);
      setStampImage([...jurisdictionStampsImages]);
      // default selecting first image
      handleStampClick(jurisdictionStampsImages[0], 0);
      setStampLoading(false);
    }

    async function getFavouriteAnnotations() {
      let favAnnotList = await fetchFavouriteAnnotation(jobId);
      setFavAnnotationList(favAnnotList);
    }

    if (isStampModalOpen) {
      setStampLoading(true);
      getJurisdictionStamp();
      getFavouriteAnnotations();
      setSelectedFavAnnotId(null);
    }
  }, [isStampModalOpen]);

  return (
    <Modal
      ariaHideApp={false}
      isOpen={isStampModalOpen}
      style={customModalStyles}
      onRequestClose={handleModalClose}
      contentLabel="Stamp Document Modal"
    >
      <div className="modal-stamp">
        <header>
          <span className="stamp-header-title">
            {" "}
            {stampTabActive ? "Stamp pages" : "Annotate page"}{" "}
          </span>
          <span onClick={handleModalClose} className="pointer-css">
            <img src={Cross} alt="Close icon" />
          </span>
        </header>

        <div className="stamp-modal-tab">
          <div
            className={
              stampTabActive ? "active-stamp-tab" : "inactive-stamp-tab"
            }
            onClick={() => setStampTabActive(true)}
          >
            Stamps
          </div>
          <div
            className={
              stampTabActive ? "inactive-stamp-tab" : "active-stamp-tab"
            }
            onClick={() => setStampTabActive(false)}
          >
            Favourite Annotations
          </div>
        </div>

        {stampTabActive ? (
          <section>
            <div>
              <div className="stamp-type-title"> Select Stamp Type </div>
              <div className="stamp-image-container">
                {stampLoading ? (
                  <FadeLoader
                    width={5}
                    radius={2}
                    margin={2}
                    height={15}
                    color={"#4183C5"}
                    loading={stampLoading}
                    css={overridestampdocument}
                  />
                ) : (
                  <React.Fragment>
                    <div className="stamp-type-box">
                      {stampImage.length > 0 &&
                        stampImage.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className={`stamp-type-image-layout ${
                                selectedImageIndex === index
                                  ? "stamp-type-image-selected"
                                  : ""
                              }`}
                            >
                              <img
                                id={`stampimage${index}`}
                                src={item}
                                alt="Stamp Images"
                                onClick={() => handleStampClick(item, index)}
                                className="stamp-type-image pointer-css"
                              />
                            </div>
                          );
                        })}
                    </div>
                    <div className="stamp-full-image-container">
                      <img
                        src={stampImage[selectedImageIndex]}
                        alt="Selected Stamp Image"
                        className="stamp-full-image"
                      />
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>

            <div className="display-mode-flex">
              <div className="stamp-type-title">
                Pages :{" "}
                <span style={{ color: "#B0B0B0" }}>
                  (Total page: {pdfPages})
                </span>
              </div>
              <div className="stamp-page-container">
                <div className="stamp-type-pages">
                  <Select
                    options={pageOption}
                    value={selectedPageMode}
                    styles={colourStylesStamps}
                    onChange={handlePageModeChange}
                    menuPortalTarget={document.body}
                  />
                </div>
                {customPageInputFlag && (
                  <input
                    type="text"
                    value={customPageInput}
                    placeholder="e.g. 1-5, 8, 11-13"
                    className="stamp-type-inputstyle"
                    onChange={(e) => handlecustomPageInputChange(e)}
                  />
                )}
              </div>
            </div>
          </section>
        ) : (
          <section>
            <div className="stamp-type-title"> Select Annotation </div>
            <div className="fav-annotations-container">
              {favAnnotationList.map((favAnnot, index) => {
                return (
                  <div
                    key={index}
                    className={`fav-annot-container ${
                      selectedFavAnnotId === favAnnot.annotationId
                        ? "selected-fav-annot-container"
                        : ""
                    }`}
                    onClick={() => setSelectedFavAnnotId(favAnnot.annotationId)}
                  >
                    <div className="modal-annotation-type">
                      {favAnnot.annotationType}
                    </div>
                    <div> {favAnnot.annotationText} </div>
                  </div>
                );
              })}
              {!favAnnotationList.length && (
                <div> Add annotations to favourite list </div>
              )}
            </div>
          </section>
        )}
        <footer>
          <div className="footer-errmsg">
            {customPageErrMsg ? <label>{customPageErrMsg}</label> : null}
          </div>
          <div className="footer-button-container">
            <label onClick={handleModalClose} className="cancel pointer-css">
              Cancel
            </label>
            <label
              onClick={() =>
                stampTabActive ? handleModalProceed() : handleFavAnnot()
              }
              className={
                (stampTabActive &&
                  selectedStampBase64 &&
                  !selectedStampBase64Loader &&
                  ((!customPageInputFlag && customPageInput === "") ||
                    (customPageInputFlag && customPageInput !== ""))) ||
                (!stampTabActive && selectedFavAnnotId)
                  ? "proceed pointer-css"
                  : "disableproceed"
              }
            >
              Proceed
            </label>
          </div>
        </footer>
      </div>
    </Modal>
  );
};

export default StampModalComponent;
